<template>
  <div class="section-header row flex-column align-items-center justify-content-center text-center m-0">
    <h4 v-if="subtitle" class="text-uppercase mb-0 text-muted">{{ subtitle }}</h4>
    <h2 :class="inverted ? 'inverted display-2 mb-0 text-uppercase' : 'display-2 mb-0 text-uppercase'">{{ title }}</h2>
  </div>
</template>
<script>
export default {
  name: "section-header",
  props: {
    title: {
      type: String,
      description: "Header title"
    },
    subtitle: {
      type: String,
      description: "Header subtitle"
    },
    inverted: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
.section-header {
  h2.inverted {
    color: #fff !important;
  }
}

</style>
